import React, { useEffect, useState } from 'react';
import { Section, SectionHeading, PRICE_USD_NEXT } from './Shared';
import { Pricing } from './Pricing';
import { tomos, bonuses } from '../data/packContents';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 0,
    s: 0
  });
  const spotsTaken = 71;
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-130" data-mp="21ssfz37fvmvv">
      <div className="bg-brand-purpleDark text-brand-goldLight font-mono font-semibold text-2xl md:text-4xl rounded-sm px-4 md:px-6 py-2.5 md:py-3.5 min-w-[64px] md:min-w-[88px] text-center tabular-nums border border-brand-gold/40" data-id="element-131" data-mp="21pcyxuu7g3rt">
        {fmt(value)}
      </div>
      <span className="font-seal text-[9px] md:text-[10px] uppercase tracking-seal text-brand-muted mt-2" data-id="element-132" data-mp="21k1xikgo8j8n">
        {label}
      </span>
    </div>;
  return <div className="max-w-3xl mx-auto mb-14" data-id="element-133" data-mp="2akq26ok6d78v">
      <div className="glass-panel gold-frame rounded-sm p-6 md:p-10" data-id="element-134" data-mp="2alhwlw21cyxk">
        <p className="font-seal text-[10px] md:text-xs uppercase tracking-seal text-brand-goldDark text-center mb-6" data-id="element-135" data-mp="2fi8dumpku0kk">
          Precio de lanzamiento — cierra en
        </p>

        <div className="flex items-start justify-center gap-3 md:gap-5 mb-7" data-id="element-136" data-mp="2p8ku42qcz7kw">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-137" data-mp="2taojzwdryepp" />
          <span className="text-2xl md:text-3xl text-brand-purpleDark/40 pt-2" data-id="element-138" data-mp="2t9ejz1nd2wgf">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Minutos" data-id="element-139" data-mp="2ybca8fu6iriv" />
          <span className="text-2xl md:text-3xl text-brand-purpleDark/40 pt-2" data-id="element-140" data-mp="338ch2syuryb1">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Segundos" data-id="element-141" data-mp="135utfb7z0mfu" />
        </div>

        <p className="text-center text-sm md:text-base text-brand-text/85 border-y border-brand-gold/30 py-3 mb-7" data-id="element-142" data-mp="y7je4kywpjq8">
          Después el precio sube a {PRICE_USD_NEXT}.{' '}
          <span className="text-brand-burgundy font-semibold" data-id="element-143" data-mp="1cyioa0fe4gbx">No vuelve.</span>
        </p>

        <div data-id="element-144" data-mp="184efdbmkdy87">
          <div className="flex items-center justify-between gap-3 mb-3" data-id="element-145" data-mp="183wa5phxc9o5">
            <span className="text-sm text-brand-purpleDark font-medium" data-id="element-146" data-mp="1lvj6tqfs3k7g">
              Cupos al precio de lanzamiento
            </span>
            <span className="font-seal text-[10px] uppercase tracking-seal text-brand-burgundy" data-id="element-147" data-mp="1vva05oslrt5y">
              Quedan pocos
            </span>
          </div>
          <div className="w-full bg-brand-surfaceLight rounded-full h-1.5 overflow-hidden border border-brand-purpleDark/10" data-id="element-148" data-mp="1qwqd1l29wbc0">
            <div className="bg-brand-burgundy h-full rounded-full transition-[width] duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-149" data-mp="1j3q4tbg3if8" />
          </div>
          <p className="text-xs text-brand-muted text-center mt-3" data-id="element-150" data-mp="287vof0fzkkak">
            <strong className="text-brand-purpleDark" data-id="element-151" data-mp="2d42wozvuu7vo">{spotsTaken}%</strong> de
            los cupos al precio de lanzamiento ya han sido reservados
          </p>
        </div>
      </div>
    </div>;
};
export const PackContents = () => <Section id="method" className="relative" data-id="element-152" data-mp="1pf1h8soltwgw">
    <SectionHeading eyebrow="El contenido" className="mb-12" data-id="element-153" data-mp="1pe09oy6srs3x">
      3 tomos principales + 6 bonus estratégicos gratis
    </SectionHeading>

    <p className="text-center text-brand-text/70 text-base md:text-lg -mt-6 mb-12 font-display italic" data-id="element-154" data-mp="1ubrwxewhyq1s">
      Más de 190 páginas. Todo resuelto.
    </p>

    <div className="max-w-5xl mx-auto mb-16" data-id="element-155" data-mp="1kgzxs6n9nv4w">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-156" data-mp="1khrw3p8906yv">
        {tomos.map(tomo => <article key={tomo.n} className="glass-panel rounded-sm flex flex-col p-5 md:p-6" data-id="element-157" data-mp="39t24yewfv9nv">
            <div className="flex items-start gap-4 mb-5 pb-5 border-b border-brand-purpleDark/10" data-id="element-158" data-mp="1es8g0jboldnb">
              <div className="relative w-16 md:w-20 shrink-0 overflow-hidden border border-brand-gold/40" data-id="element-159" data-mp="1apljw67z96kb">
                <img src={tomo.cover} alt={`Tomo ${tomo.n}: ${tomo.title}`} loading="lazy" className="w-full aspect-[3/4] object-cover" data-id="element-160" data-mp="15q8xtnoxk3is" />
              </div>
              <div className="min-w-0" data-id="element-161" data-mp="vu5ljp0d6oi4">
                <span className="block font-seal text-[9px] uppercase tracking-seal text-brand-goldDark mb-1.5" data-id="element-162" data-mp="r2e17w7sxf0f">
                  Tomo {tomo.n}
                </span>
                <h3 className="font-display font-bold text-base md:text-lg leading-tight text-brand-purpleDark" data-id="element-163" data-mp="myg6dxpieqd6">
                  {tomo.title}
                </h3>
              </div>
            </div>
            <ul className="space-y-2 text-xs md:text-[13px] text-brand-text/85" data-id="element-164" data-mp="d4h859sk3qqi">
              {tomo.features.map(f => <li key={f} className="flex items-start gap-2" data-id="element-165" data-mp="3u4ze0lhdb8uj">
                  <span aria-hidden="true" className="mt-1.5 w-1 h-1 rotate-45 bg-brand-gold shrink-0" data-id="element-166" data-mp="3u6tr5dmedwo2" />
                  <span data-id="element-167" data-mp="7ykf0j1hvpg4">{f}</span>
                </li>)}
            </ul>
          </article>)}
      </div>
    </div>

    <div className="text-center mb-8" data-id="element-168" data-mp="cuj7oituvtmc">
      <p className="font-seal text-[10px] md:text-xs uppercase tracking-seal text-brand-goldDark" data-id="element-169" data-mp="3bergciwftalq">
        6 BONUS ESTRATÉGICOS — SIEMPRE INCLUIDOS - GRATIS
      </p>
    </div>

    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 max-w-5xl mx-auto" data-id="element-170" data-mp="3lcfcnd9oyq60">
      {bonuses.map(bonus => <div key={bonus.n} className="flex flex-col" data-id="element-171" data-mp="3q3dw2lpz84dh">
          <div className="relative overflow-hidden border border-brand-gold/40 bg-brand-paper aspect-[3/4]" data-id="element-172" data-mp="3q58ik4gwc4jo">
            <img src={bonus.cover} alt={`Bonus ${bonus.n}: ${bonus.title}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" data-id="element-173" data-mp="2slx9kc8ywosl" />
            <span className="absolute top-0 right-0 bg-brand-purpleDark text-brand-goldLight font-seal text-[8px] uppercase tracking-[0.2em] px-2 py-1" data-id="element-174" data-mp="2knbtakmjsvwz">
              Gratis
            </span>
          </div>
          <p className="text-center text-[10px] md:text-[11px] text-brand-muted mt-2" data-id="element-175" data-mp="2ucby4knqelj3">
            <span className="line-through" data-id="element-176" data-mp="26n121ghbtfba">{bonus.price}</span>
            <span className="ml-1.5 text-brand-goldDark font-semibold" data-id="element-177" data-mp="26nj5oy6bivt8">
              incluido
            </span>
          </p>
        </div>)}
    </div>

    <div className="text-center mt-8" data-id="element-178" data-mp="2glqlhdovf7tn">
      <p className="inline-block border border-brand-gold/40 bg-brand-paper px-6 py-3 rounded-sm text-sm md:text-base text-brand-text" data-id="element-179" data-mp="2gmrw5h1z5sau">
        Valor total de los bonus{' '}
        <span className="line-through text-brand-muted" data-id="element-180" data-mp="3rzav6wic5vhi">54 €</span>{' '}
        <span className="text-brand-goldDark font-semibold" data-id="element-181" data-mp="3n22dsy50hvhb">
          incluidos sin coste con tu Mega Pack
        </span>
      </p>
    </div>
  </Section>;
export const MethodOverview = () => <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full" data-id="element-182" data-mp="3fa6o3asa8dc">
    <LaunchUrgency data-id="element-183" data-mp="3co30er0kd0e" />
    <Pricing data-id="element-184" data-mp="3lkn77r4kdjqu" />
  </div>;